/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import MoviesApps, { Movies2WatchApps } from "views/articles/MoviesApps"
import { AppInterface } from "types/types"
import AppsList from "components/AppsList"
import { useRouter } from "next/router"

const AddAppollowToYourHomeScreenEN = ({
  apps,
  type,
}: {
  apps: AppInterface[]
  type?: string
}) => {
  const router = useRouter()
  const article =
    router.locale === "ar"
      ? MoviesApps["ar"]
      : router.locale === "tr-TR"
      ? MoviesApps["tr"]
      : MoviesApps["en"]

  const movies2watchArticle =
    router.locale === "ar"
      ? Movies2WatchApps["ar"]
      : router.locale === "tr-TR"
      ? Movies2WatchApps["tr"]
      : Movies2WatchApps["en"]
  return (
    <InstantArticle
      {...(type === "movies2watch" ? movies2watchArticle : article)}
    >
      <div className="m-n3 mt-n4">
        <AppsList title="" apps={apps} noCard />
      </div>
    </InstantArticle>
  )
}

export default AddAppollowToYourHomeScreenEN
